import { Directive, Input, Self, Host, Optional, OnInit, Output, EventEmitter } from '@angular/core';
import { MultiSelectComponent } from '@farris/ui-multi-select';
import { ViewModel, BindingObject, BindingData } from '@farris/devkit';

@Directive({
  selector: '[multiSelectDataMapping]'
})
export class MultiSelectDataMappingDirective implements OnInit {

  @Input() dataSource: any;
  @Input() idField: string;
  @Input() textField: string;
  @Input() valueField: string;
  @Input() fjmField: string;
  @Input() fjdField: string;
  @Input() uiStateField: any;
  @Input() selectedId: string;
  @Output() selectedIdChanged = new EventEmitter<string>();
  private originalDataSource: any;

  constructor(
    @Optional() private vm: ViewModel,
    @Host() @Self() @Optional() private multiSelectComponent: MultiSelectComponent
  ) {
    this.vm.uiState.changes.subscribe(data => {
      this.selectedId = data.value;
    });
  }
  ngOnInit() {
    this.multiSelectComponent.dataSource = [];
    if (Array.isArray(this.dataSource)) {
      this.multiSelectComponent.dataSource = this.dataSource;
      this.originalDataSource = this.dataSource;
    } else if (this.dataSource && this.dataSource.changes) {
      const bindingData: BindingData = this.dataSource;
      const data = bindingData.getList().toJSON();
      this.updateDataSource(data);
      this.dataSource.changes.subscribe((change: any) => {
        if (change.type === 'Load') {
          const data = change.value;
          this.updateDataSource(data);
        }
      });
    }
    this.selectIdBindingToUIStateField();
  }
  private updateDataSource(data: any[]) {
    this.originalDataSource = data;
    if (this.multiSelectComponent.isTree()) {
      if (this.fjmField) {
        // åçº§ç å è½½æ ç»æ
        this.multiSelectComponent.dataSource = this.plainToTree(data, this.fjmField, 1);
      } else if (this.fjdField) {
        // ç¶èç¹å è½½æ ç»æ
        this.multiSelectComponent.dataSource = this.buildTreeNodesByFjd(data, this.fjdField);
      }
      this.multiSelectComponent.selections = this.getTreeSelectionsById(this.selectedId, this.originalDataSource);
    } else {
      this.multiSelectComponent.dataSource = data;
      this.multiSelectComponent.selections = this.getListSelectionsById(this.selectedId, this.multiSelectComponent.dataSource);
    }
  }
  private selectIdBindingToUIStateField() {
    if (this.multiSelectComponent && this.multiSelectComponent.selectedIdChange) {
      this.multiSelectComponent.selectedIdChange.subscribe(data => {
        this.selectedIdChanged.emit(data);
      });
    }
  }
  /**
   *
   * @param data éè¦æ ¼å¼åçæ°æ®
   */
  private formatDataSource(data: any[], field: string) {
    if (!data || !data.length) {
      return [];
    }
    return data.map(item => {
      const n = item['toJSON'] ? item.toJSON() : item;
      return {
        data: Object.assign({ ...n }, {
          [`${this.idField}`]: item[this.idField],
          [`${this.textField}`]: item[this.textField],
          [`${this.valueField}`]: item[this.valueField],
          [`${field}`]: item[field]
        }),
        children: []
      };
    });
  }
  /**
   * æå¹³è¡ç»æçæ°æ®è½¬æ¢ææ å½¢ç»æ
   * @param plainSource
   * @param field
   * @param layer
   */
  private plainToTree(plainSource: any[], field: string, layer: number) {
    const treeSource = this.formatDataSource(plainSource, field);
    if (!treeSource.length) {
      return [];
    }
    if (!treeSource[0]['data'][field]) {
      return [];
    }
    const parents = treeSource.filter(item => {
      return item['data'][field]['layer'] === layer;
    });
    this.recursive(parents, treeSource, field, 1);
    return parents;
  }

  /**
   * éå½éåæ å½¢ç»æ
   * @param parents
   * @param treeSource
   * @param field
   * @param layer
   */
  private recursive(parents: any[], treeSource: any[], field: string, layer: number) {
    parents.forEach(parent => {
      const parentPath = parent['data'][field]['path'];
      const parentLayer = parent['data'][field]['layer'];
      if (parent['data'][field]['isDetail'] === false) {
        treeSource.forEach(item => {
          if (item && item['data'] && item['data'][field] && item['data'][field]['path']) {
            const itemPath = item['data'][field]['path'];
            const itemLayer = item['data'][field]['layer'];
            let targetPath: string;
            if (itemPath && itemPath.length > parentPath.length) {
              targetPath = itemPath.substr(0, Number(layer) * 4);
            }
            if (parentPath === targetPath && parentLayer === itemLayer - 1) {
              parent['children'].push(item);
            }
            if (item['data'][field]['isDetail'] === false && parentPath === targetPath) {
              this.recursive([item], treeSource, field, Number(layer) + 1);
            }
          }
        });
      }
    });
  }
  /**
     *
     * @param ids éä¸­æ°æ®çid
     * @param dataSource åå§æ°æ®
     */
  private getListSelectionsById(ids: any, dataSource: any) {
    let result = [];
    const _this = this;
    if ((typeof ids === 'string' && !!ids) || typeof ids === 'number') {
      const reusltObj = dataSource.find(item => {
        return item && item[_this.idField] === ids;
      });
      if (reusltObj) {
        result.push(reusltObj);
      }
    } else if (Array.isArray(ids)) {
      if (dataSource) {
        ids.forEach(id => {
          const item = dataSource.find(item => item && item[_this.idField] === id);
          if (item) {
            result.push(item);
          }
        });
        // dataSource.forEach(item => {
        //   ids.forEach(id => {
        //     if (item[_this.idField] === id) {
        //       result.push(item);
        //     }
        //   })
        // })
      } else {
        result = [];
      }
    } else {
      result = [];
    }
    return result;
  }

  /**
   *
   * @param ids éä¸­æ°æ®çid
   * @param dataSource åå§æ°æ®
   */
  private getTreeSelectionsById(ids: any, dataSource: any) {
    let result = [];
    const _this = this;
    if ((typeof ids === 'string' && !!ids) || typeof ids === 'number') {
      const reusltObj = dataSource.find(item => {
        return item && item[_this.idField] === ids;
      });
      if (reusltObj) {
        result.push(reusltObj);
      }
    } else if (Array.isArray(ids)) {
      if (dataSource) {
        ids.forEach(id => {
          const item = dataSource.find(item => item && item[_this.idField] === id);
          if (item) {
            result.push(item);
          }
        });
        // dataSource.forEach(item => {
        //   ids.forEach(id => {
        //     if (item.data[_this.idField] === id) {
        //       result.push(item.data);
        //     }
        //   })
        // })
      } else {
        result = [];
      }
    } else {
      result = [];
    }
    return result;
  }



  /**
   * æ ¹æ®ç¶èç¹åå§åæ ç»æ
   * @param bindingObjects
   */
  private buildTreeNodesByFjd(bindingObjects: BindingObject[], field: string) {
    const treeData = this.formatDataSource(bindingObjects, field);
    treeData.forEach((item: any) => {
      const parent = treeData.find((ele: any) => item.data[field].parentElement === ele.data[this.idField]);
      if (parent) {
        parent.children.push(item);
      }
    });
    return treeData.filter((ele: any) => !ele.data[field].parentElement);
  }
}
